




















































































































































































































































import { Component, Mixins } from "vue-property-decorator";
import Api from "@/api";
import FormErrorsMixin from "@/mixins/FormErrors";
import { AxiosResponse } from "axios";

import NavigationTabs from "@/components/Settings/Events/EventDetails/NavigationTabs.vue";
import ViewLoader from "@/components/Common/ViewLoader.vue";
import TextInput from "@/components/Common/Inputs/TextInput.vue";
import InfoButton from "@/components/Common/Buttons/InfoButton.vue";
import BackButton from "@/components/Common/Buttons/BackButton.vue";
import DangerButton from "@/components/Common/Buttons/DangerButton.vue";
import Error404 from "@/components/Common/Error404.vue";
import swal from "sweetalert";
import { EventPriceForm, IEvent, IEventPrice, IVat } from "@/interface";

Component.registerHooks(["beforeRouteEnter", "beforeRouteUpdate"]);

@Component({
  components: {
    ViewLoader,
    NavigationTabs,
    TextInput,
    InfoButton,
    BackButton,
    DangerButton,
    Error404
  }
})
export default class EventPriceDetails extends Mixins(FormErrorsMixin) {
  public loading = false;
  public updating = false;
  public validatedInputs = ["name", "description", "form", "vat_id", "amount"];
  private noDataExist = false;
  private availableVats: Array<IVat> | null = null;
  private selectedEvent: IEvent = {
    name: null
  };
  private selectedEventId: string | null = null;
  private selectedEventPriceId: string | null = null;
  private selectedEventPrice: IEventPrice = {
    type: "secondary",
    name: null,
    description: null,
    form: EventPriceForm.NET,
    amount: 0,
    vat_id: 1,
    usable_online: false,
    customerGroup: "External"
  };

  private beforeRouteEnter(to: any, from: any, next: any): void {
    next((vm: this) => {
      vm.selectedEventId = vm.$route.params.event_id;
      vm.selectedEventPriceId = vm.$route.params.price_id;

      // Get Event
      if (
        typeof vm.selectedEventId !== "undefined" &&
        vm.selectedEventId !== null
      ) {
        vm.getEvent(() => {
          //
        });
      }

      // Get Secondary Price
      if (
        typeof vm.selectedEventPriceId !== "undefined" &&
        vm.selectedEventPriceId !== null
      ) {
        if (vm.$route.query.event_price_created === "true") {
          swal("Success!", "The price was created.", "success").then(() => {
            window.history.pushState(
              {},
              document.title,
              window.location.pathname
            );
          });
        }
        vm.getEventPrice(() => {
          //
        });
      } else {
        // Get Default Price
        vm.getDefaultPrice(() => {
          //
        });
      }
      // Get Available vats
      vm.getVats(() => {
        //
      });
    });
  }

  private beforeRouteUpdate(to: any, from: any, next: any): void {
    // Get Event
    if (
      typeof this.selectedEventId !== "undefined" &&
      this.selectedEventId !== null
    ) {
      this.getEvent(() => {
        //
      });
    }

    // Get Secondary Price
    if (
      typeof this.selectedEventPriceId !== "undefined" &&
      this.selectedEventPriceId !== null
    ) {
      this.getEventPrice(() => {
        //
      });
    } else {
      // Get Default Price
      this.getDefaultPrice(() => {
        //
      });
    }
    // Get Available vats
    this.getVats(() => {
      //
    });
    next();
  }

  private createOrUpdatePrice(): void {
    if (this.selectedEventPriceId == null) {
      this.createEventPrice();
    } else {
      this.updateEventPrice();
    }
  }

  private getEvent(successCallback?: any): void {
    this.resetErrors();
    this.loading = true;
    const endpoint: string = this.$partnerEndpoint(
      "events/" + this.selectedEventId
    );

    Api()
      .get(endpoint)
      .then((response: AxiosResponse) => {
        this.selectedEvent = response.data.data;
        if (typeof successCallback == "function") {
          successCallback();
        }
      })
      .catch((error: any) => {
        if (error.response.status === 404) {
          this.noDataExist = true;
        }
        console.log(error.response);
      })
      .finally(() => {
        this.loading = false;
      });
  }

  private getEventPrice(successCallback?: any): void {
    this.resetErrors();
    this.loading = true;
    const endpoint: string = this.$partnerEndpoint(
      "events/" + this.selectedEventId + "/prices/" + this.selectedEventPriceId
    );

    Api()
      .get(endpoint)
      .then((response: AxiosResponse) => {
        this.selectedEventPrice = response.data.data;
        this.selectedEventPrice.amount =
          response.data.data.form === "net"
            ? response.data.data.amount_net
            : response.data.data.amount_gross;
        this.selectedEventPrice.vat_id = response.data.data.vat.id;
        if (typeof successCallback == "function") {
          successCallback();
        }
      })
      .catch((error: any) => {
        if (error.response.status === 404) {
          this.noDataExist = true;
        }
        console.log(error);
      })
      .finally(() => {
        this.loading = false;
      });
  }

  private updateEventPrice(): void {
    this.resetErrors();
    this.updating = true;
    const endpoint: string = this.$partnerEndpoint(
      "events/" + this.selectedEventId + "/prices/" + this.selectedEventPriceId
    );

    Api()
      .put(endpoint, this.selectedEventPrice)
      .then((response: AxiosResponse) => {
        this.selectedEventPriceId = response.data.data.id;
        this.getEventPrice();
      })
      .catch((error: any) => {
        console.log(error);
        this.storeErrors(error.response.data.errors);
      })
      .finally(() => {
        this.updating = false;
      });
  }

  private createEventPrice(): void {
    if (this.updating) {
      return;
    }

    this.resetErrors();
    this.updating = true;
    const endpoint: string = this.$partnerEndpoint(
      "events/" + this.selectedEventId + "/prices"
    );

    Api()
      .post(endpoint, this.selectedEventPrice)
      .then((response: AxiosResponse) => {
        this.selectedEventPriceId = response.data.data.id;
        this.$router.push({
          name: "EventPriceDetails",
          params: {
            event_id: `${this.selectedEventId}`,
            price_id: `${this.selectedEventPriceId}`
          },
          query: { event_price_created: "true" }
        });
      })
      .catch((error: any) => {
        this.storeErrors(error.response.data.errors);
      })
      .finally(() => {
        this.updating = false;
      });
  }

  private deleteEventPrice(): void {
    if (this.loading || this.updating) {
      return;
    }

    swal({
      title: "Are you sure?",
      text: "The price will be deleted and will not be able to use it",
      icon: "warning",
      dangerMode: true,
      buttons: {
        cancel: {
          visible: true,
          text: "Cancel",
          closeModal: true
        },
        confirm: {
          visible: true,
          text: "Yes, delete it!",
          closeModal: true
        }
      }
    }).then(isConfirm => {
      if (isConfirm) {
        const endpoint: string = this.$partnerEndpoint(
          "events/" +
            this.selectedEventId +
            "/prices/" +
            this.selectedEventPriceId
        );

        Api()
          .delete(endpoint)
          .then((response: AxiosResponse) => {
            console.log(response.status);
            this.$router.push({
              name: "EventPrices",
              query: { event_price_deleted: "true" }
            });
          })
          .catch((error: any) => {
            console.log(error.response);
            if (error.response.status === 403) {
              swal({
                title: "Missing permission",
                text: "You are not allowed to delete event prices.",
                icon: "error"
                //dangerMode: true,
              });
            }
          });
      } else {
        //
      }
    });
  }

  private getDefaultPrice(successCallback?: any): void {
    this.resetErrors();
    this.loading = true;
    const endpoint = this.$partnerEndpoint(
      "events/" + this.selectedEventId + "/prices/default"
    );

    Api()
      .get(endpoint)
      .then((response: AxiosResponse) => {
        this.selectedEventPrice.type = response.data.data.type;
        this.selectedEventPrice.usable_online =
          response.data.data.usable_online;
        this.selectedEventPrice.form = response.data.data.form;
        this.selectedEventPrice.amount =
          response.data.data.form === "net"
            ? response.data.data.amount_net
            : response.data.data.amount_gross;
        this.selectedEventPrice.vat_id = response.data.data.vat.id;
        if (typeof successCallback == "function") {
          successCallback();
        }
      })
      .catch((error: any) => {
        console.log(error);
      })
      .finally(() => {
        this.loading = false;
      });
  }

  private getVats(successCallback?: any): void {
    this.resetErrors();
    this.loading = true;
    const endpoint: string = this.$partnerEndpoint("vats");

    Api()
      .get(endpoint)
      .then((response: AxiosResponse) => {
        this.availableVats = response.data.data;
        if (typeof successCallback == "function") {
          successCallback();
        }
      })
      .catch((error: any) => {
        console.log(error);
      })
      .finally(() => {
        this.loading = false;
      });
  }
}
